import { normalizeDateFromApi } from 'helpers/datetimeHelpers';
import { ProposalParams } from './proposals.types';

export const calculateTimeBoundaries = (
  proposal: ProposalParams | null,
): { startDate: Date | null; endDate: Date | null } | null => {
  if (!proposal) {
    return null;
  }

  const startDate =
    normalizeDateFromApi(
      proposal?.productSnapshot?.timeBoundaries?.startDate,
    ) || null;

  const rawEndDate = proposal?.productSnapshot?.timeBoundaries?.endDate;
  const endDate =
    rawEndDate === undefined || rawEndDate === null
      ? null
      : normalizeDateFromApi(rawEndDate);

  return {
    startDate,
    endDate,
  };
};
